import styled from 'styled-components';

const Animated = styled.div`
  opacity: 1;
  animation: loading 10s linear infinite;

  display: ${p => (p.inline ? 'inline-block' : 'block')};
  font-size: ${p => p.size || (p.inline ? '14px' : '40px')};
  width: ${p => (p.inline ? 'auto' : '100%')};
  height: ${p => (p.inline ? 'auto' : '100%')};
  min-height: ${p => (p.inline ? 'auto' : '50px')};
  text-align: ${p => (p.inline ? 'inherit' : 'center')};

  @keyframes loading {
    0% {
      color: transparent;
    }
    10% {
      color: transparent;
    }
    15% {
      color: ${p => p.theme.backgroundDark};
    }
    20% {
      color: transparent;
    }
    25% {
      color: ${p => p.theme.backgroundDark};
    }
    30% {
      color: transparent;
    }
    35% {
      color: ${p => p.theme.backgroundDark};
    }
    40% {
      color: transparent;
    }
    45% {
      color: ${p => p.theme.backgroundDark};
    }
    50% {
      color: transparent;
    }
    55% {
      color: ${p => p.theme.backgroundDark};
    }
    60% {
      color: transparent;
    }
    65% {
      color: ${p => p.theme.backgroundDark};
    }
    70% {
      color: transparent;
    }
    75% {
      color: ${p => p.theme.backgroundDark};
    }
    80% {
      color: transparent;
    }
    85% {
      color: ${p => p.theme.backgroundDark};
    }
    90% {
      color: transparent;
    }
    95% {
      color: ${p => p.theme.backgroundDark};
    }
    100% {
      color: transparent;
    }
  }
`;

const Loading = ({ inline = false, size = undefined }) => {
  return (
    <Animated inline={inline} size={size}>
      ...
    </Animated>
  );
};

export default Loading;
